export default {"src":"/_next/static/media/twitter-logo.2d659e08.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};